/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BadRequestResponse,
  DocumentStatusCounts,
  Folder,
  ForbiddenResponse,
  InternalServerErrorResponse,
  NotFoundResponse,
  SearchProjectPages200,
  SearchProjectPagesBody,
  SearchProjectPagesParams,
  UnauthorizedResponse,
  UpdateProjectBody
} from '.././model'
import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Get a project
 */
export const getProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Folder>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProjectQueryKey = (organizationId: string,
    projectId: string,) => {
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}`] as const;
    }

    
export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(organizationId,projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(organizationId,projectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Get a project
 */
export const useGetProject = <TData = Awaited<ReturnType<typeof getProject>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectQueryOptions(organizationId,projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a project
 */
export const updateProject = (
    organizationId: string,
    projectId: string,
    updateProjectBody: UpdateProjectBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Folder>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateProjectBody
    },
      options);
    }
  


export const getUpdateProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{organizationId: string;projectId: string;data: UpdateProjectBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{organizationId: string;projectId: string;data: UpdateProjectBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, {organizationId: string;projectId: string;data: UpdateProjectBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  updateProject(organizationId,projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = UpdateProjectBody
    export type UpdateProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Update a project
 */
export const useUpdateProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{organizationId: string;projectId: string;data: UpdateProjectBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        {organizationId: string;projectId: string;data: UpdateProjectBody},
        TContext
      > => {

      const mutationOptions = getUpdateProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a project
 */
export const deleteProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{organizationId: string;projectId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  deleteProject(organizationId,projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>
    
    export type DeleteProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Delete a project
 */
export const useDeleteProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {

      const mutationOptions = getDeleteProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Archive a project
 */
export const archiveProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/archive`, method: 'POST'
    },
      options);
    }
  


export const getArchiveProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{organizationId: string;projectId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveProject>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  archiveProject(organizationId,projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveProjectMutationResult = NonNullable<Awaited<ReturnType<typeof archiveProject>>>
    
    export type ArchiveProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Archive a project
 */
export const useArchiveProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof archiveProject>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {

      const mutationOptions = getArchiveProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Restore an archived project
 */
export const restoreProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/restore`, method: 'POST'
    },
      options);
    }
  


export const getRestoreProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,{organizationId: string;projectId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreProject>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  restoreProject(organizationId,projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RestoreProjectMutationResult = NonNullable<Awaited<ReturnType<typeof restoreProject>>>
    
    export type RestoreProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Restore an archived project
 */
export const useRestoreProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof restoreProject>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {

      const mutationOptions = getRestoreProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Performs keyword search within a project's pages using OpenSearch. Returns matching pages with highlighted snippets.
 * @summary Search within a project's pages using keyword search
 */
export const searchProjectPages = (
    organizationId: string,
    projectId: string,
    searchProjectPagesBody: SearchProjectPagesBody,
    params?: SearchProjectPagesParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SearchProjectPages200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchProjectPagesBody,
        params
    },
      options);
    }
  


export const getSearchProjectPagesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchProjectPages>>, TError,{organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchProjectPages>>, TError,{organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchProjectPages>>, {organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams}> = (props) => {
          const {organizationId,projectId,data,params} = props ?? {};

          return  searchProjectPages(organizationId,projectId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchProjectPagesMutationResult = NonNullable<Awaited<ReturnType<typeof searchProjectPages>>>
    export type SearchProjectPagesMutationBody = SearchProjectPagesBody
    export type SearchProjectPagesMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Search within a project's pages using keyword search
 */
export const useSearchProjectPages = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchProjectPages>>, TError,{organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof searchProjectPages>>,
        TError,
        {organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams},
        TContext
      > => {

      const mutationOptions = getSearchProjectPagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get document status counts for a project
 */
export const getProjectDocumentsStatuses = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentStatusCounts>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/documents-statuses`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProjectDocumentsStatusesQueryKey = (organizationId: string,
    projectId: string,) => {
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/documents-statuses`] as const;
    }

    
export const getGetProjectDocumentsStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getProjectDocumentsStatuses>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDocumentsStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectDocumentsStatusesQueryKey(organizationId,projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectDocumentsStatuses>>> = ({ signal }) => getProjectDocumentsStatuses(organizationId,projectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectDocumentsStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectDocumentsStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectDocumentsStatuses>>>
export type GetProjectDocumentsStatusesQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Get document status counts for a project
 */
export const useGetProjectDocumentsStatuses = <TData = Awaited<ReturnType<typeof getProjectDocumentsStatuses>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectDocumentsStatuses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectDocumentsStatusesQueryOptions(organizationId,projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



